import React from 'react'
import { Link } from 'react-router-dom'
import { companyInfo, socialLinks } from '../data/companyInfo'

function TourguideCard(props) {
    const { guideID, guideThumb, guideImage, guideTitle, guideDesignation } = props;
    return (
        <div className="th-team team-grid">
            <div className="team-img">
                <img src={`/assets/img/team/${guideThumb}`} alt={guideTitle} />
            </div>
            <div className="team-img2">
                <img src={`/assets/img/team/${guideImage}`} alt={guideTitle} />
            </div>
            <div className="team-content">
                <div className="media-body">
                    <h3 className="box-title">
                        <Link to={`/tour-guide/${guideID}`}>{guideTitle || 'Tour Guide'}</Link>
                    </h3>
                    <span className="team-desig">{guideDesignation || 'Tourist Guide'}</span>
                    <div className="th-social">
                        <Link target="_blank" rel="noopener noreferrer" to={socialLinks.facebook}>
                            <i className="fab fa-facebook-f" />
                        </Link>
                        <Link target="_blank" rel="noopener noreferrer" to={socialLinks.whatsapp}>
                            <i className="fab fa-whatsapp" />
                        </Link>
                        <Link target="_blank" rel="noopener noreferrer" to={socialLinks.instagram}>
                            <i className="fab fa-instagram" />
                        </Link>
                        <Link target="_blank" rel="noopener noreferrer" to={socialLinks.tiktok}>
                            <i className="fab fa-tiktok" />
                        </Link>
                        <Link target="_blank" rel="noopener noreferrer" to={`mailto:${companyInfo.email}`}>
                            <i className="fas fa-envelope" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TourguideCard
